import { DatePipe, NgOptimizedImage } from "@angular/common";
import { provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { ErrorHandler, inject, isDevMode, NgModule, provideAppInitializer } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import { RouteReuseStrategy } from "@angular/router";
import { ServiceWorkerModule } from "@angular/service-worker";
import { IonicModule, IonicRouteStrategy } from "@ionic/angular";
import { IonicStorageModule } from "@ionic/storage-angular";
import { provideTranslateService } from "@ngx-translate/core";
import { provideTranslateHttpLoader } from "@ngx-translate/http-loader";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { platformProviders } from "./core/platform/platform.providers";
import { keyboardOptionsForHost } from "./native-host";
import { GraphQLModule } from "./module/graphql/graphql.module";
import { CoordinatesPipe } from "./pipes/coordinates/coordinates.pipe";
import { MainPipe } from "./pipes/pipes.module";
import { sentryErrorHandler } from "./sentry";
import { EnvironmentService } from "./services/env/env.service";
import { GraphqlService } from "./services/graphql/graphql.service";
import { MissionPopupComponent } from "./components/mission-popup/mission-popup.component";

@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    FormsModule,
    IonicModule.forRoot(keyboardOptionsForHost(typeof window !== "undefined" && window.__efbNativeMac === true)),
    IonicStorageModule.forRoot(),
    AppRoutingModule,
    MainPipe,
    GraphQLModule,
    NgOptimizedImage,
    MissionPopupComponent,
    ServiceWorkerModule.register("ngsw-worker.js", {
      enabled: !isDevMode(),
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: "registerWhenStable:30000",
    }),
  ],
  providers: [
    provideAppInitializer(() => {
      const api = inject(EnvironmentService).getApiInfo();
      inject(GraphqlService);
      return api;
    }),
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: ErrorHandler, useValue: sentryErrorHandler },
    CoordinatesPipe,
    DatePipe,
    provideHttpClient(withInterceptorsFromDi()),
    provideTranslateService({
      loader: provideTranslateHttpLoader({
        prefix: "/assets/i18n/",
        suffix: ".json",
      }),
      fallbackLang: "de",
      lang: "de",
    }),
    ...platformProviders,
  ],
})
export class AppModule {}
